import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/index'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'


import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
});

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTable, faClipboardList, faUserFriends, faFileAlt, faDolly, faChartBar, faCogs, faPlus, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import moment from 'moment'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import axios from 'axios'
import { getToken, clearSession } from './auth'
Vue.prototype.$http = axios

axios.defaults.baseURL = process.env.VUE_APP_COMMERCE_API

axios.defaults.headers.common = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

// Send the Sanctum token with every API request.
axios.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Token missing, expired or revoked: sign out and go back to the login page.
axios.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401 && !error.config.url.endsWith('/login')) {
    clearSession()
    if (router.currentRoute.name !== 'Home') {
      router.push({ name: 'Home', query: { redirect: router.currentRoute.fullPath } })
    }
  }
  return Promise.reject(error)
})

// PDF reports open in a new tab, which can't send the token, so ask the API
// for a short-lived signed link first. The tab is opened straight away so
// mobile browsers don't treat it as a pop-up.
Vue.prototype.$openPdf = function (type, id) {
  const tab = window.open('', '_blank')
  axios.get(`/api/pdf-link/${type}/${id}`)
    .then(({ data }) => {
      if (tab) {
        tab.location = data.data.url
      } else {
        window.location = data.data.url
      }
    })
    .catch(err => {
      if (tab) tab.close()
      console.log(err)
    })
}

require('@/assets/css/app.css')

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);

library.add(faTable, faClipboardList, faUserFriends, faFileAlt, faDolly, faChartBar, faCogs, faPlus, faAngleDoubleRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('v-select', vSelect)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
